// import Detail from '@/components/News/detail';
import dynamic from 'next/dynamic';
const Detail = dynamic(() => import('@/components/News/detail'));
export default Detail;
export async function getServerSideProps(context) {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/post/${context.params.sort_url}?view=true`,
      {
        headers: {
          'Content-Type': 'application/json',
          locale: context.locale,
        },
      },
    );
    const data = await res.json();
    const data_value = data.data.find(
      it => it.language.sign === context.locale,
    );
    if (
      !data ||
      data.code !== 200 ||
      (data.code === 200 && !data_value.category_id && !data_value.title)
    ) {
      return {
        notFound: true,
      };
    }

    return {
      props: data_value, // will be passed to the page component as props
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
